import React, { useContext, useEffect, useState } from "react";
import ButtonWithIcon from "../../Components/Reusable/ButtonWithIcon";
import { SvgImages } from "../../Utils/LocalImages";
import { InputType, handleApiErrors, validationRegex } from "../../Utils/Utils";
import CustomTextField from "../../Components/Reusable/CustomTextField";
import CustomTextArea from "../../Components/Reusable/CustomTextArea";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import HomeSliderService from "../../Services/HomeSliderService";
import { useLocation } from "react-router-dom";
import { AuthContext } from "../../Context/authContext";
import { set } from "date-fns";

const UpdateMobileBanner = () => {
    const [sliderData, setSliderData] = useState({});
    const [Sliderdataedit, setTestimonialEdit] = useState({ ...useLocation().state });
    const [uploadimagemobileone, setUploadimagemobileone] = useState(Array());
    const [uploadimagemobiletwo, setUploadimagemobiletwo] = useState(Array());
    const [uploadimagemobilethree, setUploadimagemobilethree] = useState(Array());
    const [middlebannerimage, setMiddlebannerimage] = useState(Array());
    const [lastbannerimage, setLastbannerimage] = useState(Array());
    const { user } = useContext(AuthContext)

    const Validations = yup.object().shape({
        uploadimagemobileone: validationRegex.required,
        uploadimagemobiletwo: validationRegex.required,
        uploadimagemobilethree: validationRegex.required,
        middlebannerimage: validationRegex.required,
        lastbannerimage: validationRegex.required,
    });
    const {
        register,
        handleSubmit,
        setValue,
        formState: { errors: errors },
        reset,
    } = useForm({
        resolver: yupResolver(Validations),
        defaultValues: {
            uploadimagemobileone: Sliderdataedit?.uploadImageOne || "",
            uploadimagemobiletwo: Sliderdataedit?.uploadImageTwo || "",
            uploadimagemobilethree: Sliderdataedit?.uploadImageThree || "",
            middlebannerimage: Sliderdataedit?.uploadMiddleImage || "",
            lastbannerimage: Sliderdataedit?.uploadLastImage || "",
        },
    })

    useEffect(() => {
        getHomeSliderData();
    }, []);

    const getHomeSliderData = async () => {
        try {
            const response = await HomeSliderService.getHomeSliderData();
            const data = response.mobileBanner;
            setSliderData(data);
            setValue("uploadimagemobileone", data.uploadImageOne);
            setValue("uploadimagemobiletwo", data.uploadImageTwo);
            setValue("uploadimagemobilethree", data.uploadImageThree);
            setValue("middlebannerimage", data.uploadMiddleImage);
            setValue("lastbannerimage", data.uploadLastImage);
        } catch (error) {
            handleApiErrors(error);
        }
    };


    const onSubmit = async (sliderupdateimage) => {        
        const updatePrivilege = user?.setPrivileges?.find(
            (priv) => priv.parameter === "Updateslider"
        );
        if (updatePrivilege?.update) {
            try {
                // Call TestimonialService to add the blog
                const response = await HomeSliderService.updateMobileBanner(
                    sliderupdateimage.uploadimagemobileone === "[object FileList]" ? uploadimagemobileone : sliderupdateimage?.uploadimagemobileone,
                    sliderupdateimage.uploadimagemobiletwo === "[object FileList]" ? uploadimagemobiletwo : sliderupdateimage?.uploadimagemobiletwo,
                    sliderupdateimage.uploadimagemobilethree === "[object FileList]" ? uploadimagemobilethree : sliderupdateimage?.uploadimagemobilethree,
                    sliderupdateimage.middlebannerimage === "[object FileList]" ? middlebannerimage : sliderupdateimage?.middlebannerimage,
                    sliderupdateimage.lastbannerimage === "[object FileList]" ? lastbannerimage : sliderupdateimage?.lastbannerimage,


                );
                toast.success(response.message);

                navigate(RoutesPath.updateSlider);
            } catch (error) {
                handleApiErrors(error);
            }
        } else {
            toast.warning("You don't have permission to update slider.");
        }
    };

    return (
        <div>
            <div className="mb-3 d-flex justify-content-between align-items-center">
                <h1 className="black fs-18 fw-600 mb-0">Update Mobile Banners </h1>
                <div className="d-flex">
                    <h4 className="fs-12 fw-500 black mb-0 me-1">Dashboard &gt;</h4>
                    <h4 className="fs-12 fw-500 primary mb-0">Update Mobile Banners</h4>
                </div>
            </div>
            <div className="table_container" style={{ display: "block" }}>
                <div class="row updateslidersection">
                    <div className="table_title col-md-12">
                        <div className="table_headings">
                            <h1 className="black fs-18 fw-600 mb-0">
                                First 3 Banners<span className="fs-18 danger">*
                                </span>
                            </h1>
                        </div>
                    </div>
                    <div className="col-md-6 pb-4 profile_inputs">

                        {/* <div className="">
                            <CustomTextField
                                labelTitle="Upload Image"
                                placeholder="Upload File"
                                name="sliderOneImage"
                                id="sliderOneImage"
                                additionalClasses="select_file "
                                inputType={InputType.file}
                                showMandatory={true}
                                register={register}
                                // showError={errors?.uploadimageone}
                                // // errorMessage={errors?.uploadimageone?.message}
                                defaultValue={sliderData?.sliderOneImage || ""}
                            />
                        </div> */}
                        <label className="login_heading">Upload Image 1<span className="danger fs-14 fw-400 mt-1">*(Extension: File: jpg, png, JPG, PNG, JPEG, WEBP) </span></label>
                        <div className="position-relative select_file ">
                            <input
                                type="file"
                                name="uploadimagemobileone"
                                className="choose-file"
                                accept="image/jpeg, image/jpg, image/webp, image/png"
                                {...register("uploadimagemobileone", {
                                    required: true,
                                    message: "this is required",
                                })}


                                onChange={(e) => {
                                    if (e.target.files.length > 0) {
                                        const file = e.target.files[0];
                                        const validTypes = ["image/jpeg", "image/jpg", "image/webp", "image/png"]; // Updated to include PNG
                                        if (!validTypes.includes(file.type)) {
                                            toast.error("Only JPG, JPEG, PNG, and WEBP files are allowed."); // Updated error message
                                            e.target.value = null; // Clear the input value
                                        } else {
                                            setUploadimagemobileone(file);
                                        }
                                    }
                                }}
                            />
                            {errors.uploadimagemobileone && (
                                <p className="danger fs-14 fw-400">{errors.uploadimagemobileone.message}</p>
                            )}
                            {sliderData?.uploadImageOne && (
                                <p className="text-success fs-14 fw-400 mt-1">Selected file: {sliderData.uploadImageOne}</p>
                            )}
                        </div>
                    </div>
                    <div className="col-md-6 pb-4 profile_inputs">

                        {/* <div className="">
                            <CustomTextField
                                labelTitle="Upload Image"
                                placeholder="Upload File"
                                name="sliderOneImage"
                                id="sliderOneImage"
                                additionalClasses="select_file "
                                inputType={InputType.file}
                                showMandatory={true}
                                register={register}
                                // showError={errors?.uploadimageone}
                                // // errorMessage={errors?.uploadimageone?.message}
                                defaultValue={sliderData?.sliderOneImage || ""}
                            />
                        </div> */}
                        <label className="login_heading">Upload Image 2<span className="danger fs-14 fw-400 mt-1">*(Extension: File: jpg, png, JPG, PNG, JPEG, WEBP) </span></label>
                        <div className="position-relative select_file ">
                            <input
                                type="file"
                                name="uploadimagemobiletwo"
                                className="choose-file"
                                accept="image/jpeg, image/jpg, image/webp, image/png"
                                {...register("uploadimagemobiletwo", {
                                    required: true,
                                    message: "this is required",
                                })}


                                onChange={(e) => {
                                    if (e.target.files.length > 0) {
                                        const file = e.target.files[0];
                                        const validTypes = ["image/jpeg", "image/jpg", "image/webp", "image/png"]; // Updated to include PNG
                                        if (!validTypes.includes(file.type)) {
                                            toast.error("Only JPG, JPEG, PNG, and WEBP files are allowed."); // Updated error message
                                            e.target.value = null; // Clear the input value
                                        } else {
                                            setUploadimagemobiletwo(file);
                                        }
                                    }
                                }}
                            />
                            {errors.uploadimagemobiletwo && (
                                <p className="danger fs-14 fw-400">{errors.uploadimagemobiletwo.message}</p>
                            )}
                            {sliderData?.uploadImageTwo && (
                                <p className="text-success fs-14 fw-400 mt-1">Selected file: {sliderData.uploadImageTwo}</p>
                            )}
                        </div>
                    </div>
                    <div className="col-md-6 pb-4 profile_inputs">

                        {/* <div className="">
                            <CustomTextField
                                labelTitle="Upload Image"
                                placeholder="Upload File"
                                name="sliderOneImage"
                                id="sliderOneImage"
                                additionalClasses="select_file "
                                inputType={InputType.file}
                                showMandatory={true}
                                register={register}
                                // showError={errors?.uploadimageone}
                                // // errorMessage={errors?.uploadimageone?.message}
                                defaultValue={sliderData?.sliderOneImage || ""}
                            />
                        </div> */}
                        <label className="login_heading">Upload Image 3<span className="danger fs-14 fw-400 mt-1">*(Extension: File: jpg, png, JPG, PNG, JPEG, WEBP) </span></label>
                        <div className="position-relative select_file ">
                            <input
                                type="file"
                                name="uploadimagemobilethree"
                                className="choose-file"
                                accept="image/jpeg, image/jpg, image/webp, image/png"
                                {...register("uploadimagemobilethree", {
                                    required: true,
                                    message: "this is required",
                                })}


                                onChange={(e) => {
                                    if (e.target.files.length > 0) {
                                        const file = e.target.files[0];
                                        const validTypes = ["image/jpeg", "image/jpg", "image/webp", "image/png"]; // Updated to include PNG
                                        if (!validTypes.includes(file.type)) {
                                            toast.error("Only JPG, JPEG, PNG, and WEBP files are allowed."); // Updated error message
                                            e.target.value = null; // Clear the input value
                                        } else {
                                            setUploadimagemobilethree(file);
                                        }
                                    }
                                }}
                            />
                            {errors.uploadimagemobilethree && (
                                <p className="danger fs-14 fw-400">{errors.uploadimagemobilethree.message}</p>
                            )}
                            {sliderData?.uploadImageThree && (
                                <p className="text-success fs-14 fw-400 mt-1">Selected file: {sliderData.uploadImageThree}</p>
                            )}
                        </div>
                    </div>

                    <div className="table_title col-md-12 ">
                        <div className="table_headings">
                            <h1 className="black fs-18 fw-600 mb-0">
                                Middle Banner<span className="fs-18 danger">*
                                </span>
                            </h1>
                        </div>
                    </div>
                    <div className="col-md-6  pb-4 profile_inputs">

                        {/* <div className="">
                            <CustomTextField
                                labelTitle="Upload Image"
                                placeholder="Upload File"
                                name="sliderTwoImage"
                                id="sliderTwoImage"
                                additionalClasses="select_file "
                                inputType={InputType.file}
                                showMandatory={true}
                                register={register}
                                // showError={errors?.sliderTwoImage}
                                // errorMessage={errors?.sliderTwoImage?.message}
                                defaultValue={sliderData?.sliderTwoImage || ""}
                            />
                        </div> */}
                        <label className="login_heading">Upload Image<span className="danger fs-14 fw-400 mt-1">*(Extension: File: jpg, png, JPG, PNG, JPEG, WEBP) </span></label>
                        <div className="position-relative select_file ">
                            <input
                                type="file"
                                name="middlebannerimage"
                                className="choose-file"
                                accept="image/jpeg, image/jpg, image/webp, image/png"
                                {...register("middlebannerimage", {
                                    required: true,
                                    message: "this is required",
                                })}


                                onChange={(e) => {
                                    if (e.target.files.length > 0) {
                                        const file = e.target.files[0];
                                        const validTypes = ["image/jpeg", "image/jpg", "image/webp", "image/png"]; // Updated to include PNG
                                        if (!validTypes.includes(file.type)) {
                                            toast.error("Only JPG, JPEG, PNG, and WEBP files are allowed."); // Updated error message
                                            e.target.value = null; // Clear the input value
                                        } else {
                                            setMiddlebannerimage(file);
                                        }
                                    }
                                }}
                            />
                            {errors.middlebannerimage && (
                                <p className="danger fs-14 fw-400">{errors.middlebannerimage.message}</p>
                            )}
                            {sliderData?.uploadMiddleImage && (
                                <p className="text-success fs-14 fw-400 mt-1">Selected file: {sliderData.uploadMiddleImage}</p>
                            )}
                        </div>

                    </div>

                    <div className="table_title col-md-12">
                        <div className="table_headings">
                            <h1 className="black fs-18 fw-600 mb-0">
                                Last Banner<span className="fs-18 danger">*
                                </span>
                            </h1>
                        </div>
                    </div>
                    <div className="col-md-6  profile_inputs">

                        {/* <div className="col-md-6 col-lg-12">
                            <CustomTextField
                                labelTitle="Upload Image"
                                placeholder="Upload File"
                                name="sliderThreeImage"
                                id="sliderThreeImage"
                                additionalClasses="select_file "
                                inputType={InputType.file}
                                showMandatory={true}
                                register={register}
                                // showError={errors?.sliderThreeImage}
                                // errorMessage={errors?.sliderThreeImage?.message}
                                defaultValue={sliderData?.sliderThreeImage || ""}
                            />
                        </div> */}
                        <label className="login_heading">Upload Image<span className="danger fs-14 fw-400 mt-1">*(Extension: File: jpg, png, JPG, PNG, JPEG, WEBP) </span></label>
                        <div className="position-relative select_file ">
                            <input
                                type="file"
                                name="lastbannerimage"
                                className="choose-file"
                                accept="image/jpeg, image/jpg, image/webp, image/png"
                                {...register("lastbannerimage", {
                                    required: true,
                                    message: "this is required",
                                })}
                                errorMessage={errors?.lastbannerimage?.message}

                                onChange={(e) => {
                                    if (e.target.files.length > 0) {
                                        const file = e.target.files[0];
                                        const validTypes = ["image/jpeg", "image/jpg", "image/webp", "image/png"]; // Updated to include PNG
                                        if (!validTypes.includes(file.type)) {
                                            toast.error("Only JPG, JPEG, PNG, and WEBP files are allowed."); // Updated error message
                                            e.target.value = null; // Clear the input value
                                        } else {
                                            setLastbannerimage(file);
                                        }
                                    }
                                }}
                            />
                            {errors.lastbannerimage && (
                                <p className="danger fs-14 fw-400">{errors.lastbannerimage.message}</p>
                            )}
                            {sliderData?.uploadLastImage && (
                                <p className="text-success fs-14 fw-400 mt-1">Selected file: {sliderData.uploadLastImage}</p>
                            )}
                        </div>
                        {/* {packages.mainImage && (
                                    <p className="text-success fs-14 fw-400 my-1">Selected file: {packages.mainImage}</p>
                                )}
                                {errorsStepOne.mainImage && (
                                    <p className="danger fs-14 fw-400 my-1">{errorsStepOne.mainImage.message}</p>
                                )} */}
                    </div>

                    <div className="d-flex justify-content-end mt-3">
                        <ButtonWithIcon
                            text={"Update"}
                            icon={SvgImages.right_arrow}
                            onClick={handleSubmit(onSubmit)}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UpdateMobileBanner;
